import React, { useContext } from 'react';
// import PropTypes from 'prop-types';
import { authContext } from 'contexts/AuthContext';
import { allowedUserChecker } from 'utils/constants';

const RBAC = ({ allowedRoles, children: Component, disabled = false }) => {
  const { auth } = useContext(authContext);
  const {
    data: { roles },
  } = auth;

  const access = allowedUserChecker(roles, allowedRoles);
  if (!disabled) return access ? Component : null;
  return React.cloneElement(<Component />, { access });
};

// RBAC.propTypes = {
//   allowedRoles: PropTypes.arrayOf(PropTypes.string),
//   children: PropTypes.element,
// };

export default RBAC;
